import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import useravatar from '../bgPhoto/ava.gif';
import { Link, useNavigate } from 'react-router-dom';
import TopBar from '../Bars/TopBar';
import useIsPhone from '../Main/useIsPhone';
import AddClientModal from '../Handle_Accounts/AddClientModal';
import { PROXY } from '../components/constants';
import SideBar from '../Bars/SideBar';

function Clients() {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const isPhone = useIsPhone();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    axios.get(`${PROXY}/faccounts`)
      .then(res => setData(res.data))
      .catch(err => console.log(err));
  }, []);

  const [userData, setUserData] = useState(null);
  axios.defaults.withCredentials = true;

  useEffect(() => {
    axios.get(`${PROXY}/session`)
      .then(res => {
        if (res.data.valid) {
          console.log("User data from response:", res.data.userData);
          setUserData(res.data.userData);
          if (res.data.userData.account_type !== 1) {
            navigate('/');
          }
        } else {
          console.log("Redirecting to login page");
          navigate('/');
        }
      })
      .catch(err => console.log(err));
  }, []);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = data.filter(accounts =>
    accounts.account_type === 3 &&
    `${accounts.first_name} ${accounts.middle_name} ${accounts.last_name}`.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="flex flex-col md:flex-row h-screen pagescreen">
      <SideBar/>
      <div className="flex-1 overflow-auto">
        <TopBar/>
        <div className="mt-4 flex justify-end items-center mr-10">
  <div className="flex items-center space-x-4">
    <input
      type="text"
      placeholder="Search..."
      className="text-black searchbar px-10 py-2 border rounded"
      value={searchQuery}
      onChange={handleSearch}
      style={{ width: isPhone ? '100%' : 'auto' }}
    />
    <button
      onClick={openModal}
      className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 rounded"
      style={{
        width: isPhone ? '100%' : 'auto',
        fontSize: isPhone ? '15px' : 'inherit',
        height: isPhone ? '100%' : 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <FontAwesomeIcon icon={faPlus} className="mr-2" />
        <span>{isPhone ? 'Add' : 'Add Account'}</span>
      </div>
    </button>
  </div>
  <AddClientModal isOpen={isModalOpen} onClose={closeModal} />
</div>

        <div className="mt-[12%] flex flex-wrap justify-start" style={{ display: isPhone ? 'grid': '', gridTemplateColumns: isPhone ? 'repeat(2, 1fr)' : 'auto', marginBottom: isPhone ? '50px' : ''}}>
          {filteredData.map((accounts, index) => (
            <Link to={`/clientinfo/${accounts.id}`} key={index} className="clientLink">
              <div className="clientbox p-6 mr-1 mb-[40%] ml-20" style={{ width: isPhone ? '75%' : '300px', marginLeft: isPhone ? '13%' : '', height: isPhone ? '40%' : '', paddingBottom: isPhone ? '140px' : '', marginBottom: isPhone ? '-40px' : ''}}>
                <div className="mt-[-50%]">
                  {accounts.image ? (
                    <img src={`http://localhost:8081/uploads/${accounts.image}`} className="clientIcon fixed-size-image text-white text-2xl mr-4 cursor-pointer" style={{width: isPhone ? '100%' : 'auto', height: isPhone ? '120px' : '', marginLeft: isPhone ? '1px' : '10%'}} alt="User Icon"/>
                  ) : (
                    <img src={useravatar} className="clientIcon fixed-size-image text-white text-2xl mr-4 cursor-pointer" style={{width: isPhone ? '100%' : 'auto', height: isPhone ? '120px' : '', marginLeft: isPhone ? '1px' : '10%'}} alt="Default User Icon"/>
                  )}
                  <br/>
                  <p className="clientname mt-[-10px] text-black font-semibold" style={{fontSize: isPhone ? '15px' : 'auto', marginTop: isPhone ? '-10px' : ''}}>{`${accounts.first_name || ''} ${accounts.middle_name ? accounts.middle_name + ' ' : ''}${accounts.last_name || ''}`}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Clients;
